import React from 'react'
import createIcon from '@/lib/create-icon'

export const SlidersSVGIcon = createIcon(
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 10.5V7M2 5V1.5M6 10.5V6M6 4V1.5M10 10.5V8M10 6V1.5M0.5 7H3.5M4.5 4H7.5M8.5 8H11.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
